import React from "react";
import PurchaseOrderDetails from "pages/Procurement/PurchaseOrder/View/PurchaseOrderDetails";

interface PurchaseOrderViewComponentProps {
  id: string;
}

export const PurchaseOrderViewComponent: React.FC<PurchaseOrderViewComponentProps> = ({
  id,
}) => {
  return <PurchaseOrderDetails id={id} />;
};
